import React, { useContext } from 'react';
import { Select } from '@qover/molecules';
import { LocaleContext } from '@qover/contexts';

export function LanguageSelector(): JSX.Element | null {
  const { changeLocale, countryLocales, locale } = useContext(LocaleContext);

  function handleChange(value: string) {
    // @ts-ignore
    dataLayer.push({
      event: 'languageEvent',
      eventCategory: 'Language',
      eventAction: locale, // Current language
      eventLabel: value, // New language
    });
    changeLocale(value, true);
  }

  return countryLocales.length > 1 ? (
    <Select
      className="small"
      data-test="language.selector"
      onChange={e => handleChange(e.target.value)}
      value={locale.value}
      required
    >
      {countryLocales.map((l, idx) => (
        <option key={idx} value={l}>
          {l.substring(0, 2).toUpperCase()}
        </option>
      ))}
    </Select>
  ) : null;
}
